module.exports = __webpack_public_path__ + "static/media/stripe.470559cc.svg";